<div class="py-2 px-0">
  <div class="incident-search-wrapper">
    <div>
      <span style="font-weight: 600; font-size: 1.1rem; color: #fff; flex: 1;">
        Facilities <small>({{dataItemsFiltered.length}})</small>
      </span>

    </div>

    <div class="d-flex mb-1 gap-2 " style="margin-top: 8px; position: relative;">
      <input class="listSearch form-control" type="text" id="searchinput" [(ngModel)]="query" (input)="onSearch()"
        placeholder="Search Facility" autofocus />
        <i class="fa fa-search search-icon-wrapper"></i>

      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="custom-scroll v2" id="buildings-list-scroll">
          <table class="table table-striped table-hover custom-table">
            <tbody>
              @for (item of dataItemsFiltered; track item) {
                <tr (click)="goToFacility(item)">
                  <td class="">
                    <div class="row">
                      <div class="col-lg-8">
                        {{ item.label }}
                      </div>
                      <div class="col-lg-4 d-flex">
                        <i class="fa-solid fa-circle-info p-1"
                          (click)="getFacilityInfo($event, item)"
                        style="cursor: pointer" title="view info"></i>
                        <i class="fa fa-envelope p-1"
                          (click)="messagePOC($event, item)"
                        style="cursor: pointer" aria-hidden="true" title="send message"></i>
                      </div>
                    </div>
                    @if (containsBasePerimeter(item) && !orgIsGG()) {
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="incident-actions" style="border:none">
                            @for (cat of (incidentCategoryList[item.organizationId] | slice:0:4); track cat) {
                              <button
                                type="button"
                                class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
                                (click)="panicButtonPressed($event, item, cat)"
                                style="padding: 0px"
                                >
                                <img
                                  [src]="'assets/img/glyphicons/glyphicons-' + cat.iconCode + '.png'"
                                  [title]="cat.label"
                                  class="icon_border"
                                  />
                                </button>
                              }
                              <button
                                type="button"
                                class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
                                (click)="panicButtonPressed($event, item, null)"
                                style="padding: 0px"
                                >
                                <i class="fa fa-pencil fa-1x text-white icon_i" title="Other Emergency"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
